import request from '@/utils/request'

/**
 * 批量添加题目到课程
 * @param {Number} courseId 课程ID
 * @param {Array} questionIds 题目ID列表
 */
export function addQuestionsToCourse(courseId, questionIds) {
  return request({
    url: '/course-questions/add-to-course',
    method: 'post',
    data: {
      courseId: Number(courseId),
      questionIds: questionIds.map(id => Number(id)),
      questionType: 'amc' // 指定为 AMC 题目类型
    }
  })
}

/**
 * 从课程移除题目
 * @param {Number} courseId 课程ID
 * @param {Number} questionId 题目ID
 */
export function removeQuestionFromCourse(courseId, questionId) {
  return request({
    url: `/course-questions/${Number(courseId)}/${Number(questionId)}`,
    method: 'delete',
    params: { questionType: 'amc' }
  })
}

/**
 * 获取课程的所有题目
 * @param {Number} courseId 课程ID
 */
export function getCourseQuestions(courseId) {
  return request({
    url: `/course-questions/${Number(courseId)}/all`,
    method: 'get'
  })
}

/**
 * 检查题目是否在课程中
 * @param {Number} courseId 课程ID
 * @param {Number} questionId 题目ID
 */
export function checkQuestionInCourse(courseId, questionId) {
  return request({
    url: `/course-questions/check/${Number(courseId)}/${Number(questionId)}`,
    method: 'get'
  })
}
